import React, { SFC } from "react";
import { Paragraph } from "scuid-x";
import * as RejectImage from "../../assets/images/exit-symbol.svg";
import * as AcceptImage from "../../assets/images/success-check-symbol.svg";
import "./ImageReview.css";

export interface ImageReviewProps {
  image: string;
  acceptImage: () => void;
  rejectImage: () => void;
}

export const ImageReview: SFC<ImageReviewProps> = (props: ImageReviewProps) => {

  return (
    <div className={"ImageReview-container"}>
      <img className={"ImageReview-image"} src={props.image}/>
      <div className={"ImageReview-text-container"}>
        <Paragraph className={"ImageReview-text"}>
          Would you like to keep this image or try again?
        </Paragraph>
      </div>
      <img
        className={"ImageReview-accept-button"}
        src={AcceptImage}
        onClick={props.acceptImage}
      />
      <img
        className={"ImageReview-decline-button"}
        src={RejectImage}
        onClick={props.rejectImage}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/doc-capture/ImageReview.tsx